import { render, staticRenderFns } from "./CustomerListInfo.vue?vue&type=template&id=49cd8672&scoped=true&"
import script from "./CustomerListInfo.vue?vue&type=script&lang=js&"
export * from "./CustomerListInfo.vue?vue&type=script&lang=js&"
import style0 from "./CustomerListInfo.vue?vue&type=style&index=0&id=49cd8672&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cd8672",
  null
  
)

export default component.exports